import { FETCH_ALERT_PREFERENCES, FETCH_ALERT_PREFERENCES_DONE, FETCH_ALERT_PREFERENCES_ERROR, SET_ALERT_PREFERENCES, SET_ALERT_PREFERENCES_DONE, SET_ALERT_PREFERENCES_ERROR, RESET_ALERT_PREFERENCES, SET_ALERT_CHANNEL, SET_ALERT_CHANNEL_DONE, SET_ALERT_CHANNEL_ERROR } from './actionTypes';
export const fetchAlertPreferences = () => ({
    type: FETCH_ALERT_PREFERENCES
});
export const fetchAlertPreferencesDone = (data) => ({
    type: FETCH_ALERT_PREFERENCES_DONE,
    data
});
export const fetchAlertPreferencesError = (data) => ({
    type: FETCH_ALERT_PREFERENCES_ERROR,
    data
});
export const setAlertPreferences = (data) => ({
    type: SET_ALERT_PREFERENCES,
    data
});
export const setAlertPreferencesDone = () => ({
    type: SET_ALERT_PREFERENCES_DONE
});
export const setAlertPreferencesError = (data) => ({
    type: SET_ALERT_PREFERENCES_ERROR,
    data
});
export const resetAlertPreferences = () => ({
    type: RESET_ALERT_PREFERENCES
});
export const setAlertChannel = (data) => ({
    type: SET_ALERT_CHANNEL,
    data
});
export const setAlertChannelDone = (data) => ({
    type: SET_ALERT_CHANNEL_DONE,
    data
});
export const setAlertChannelError = (data) => ({
    type: SET_ALERT_CHANNEL_ERROR,
    data
});
//# sourceMappingURL=actionCreators.js.map